import { useId } from "react";

export const SP_HEART = "💖";

export function SpHeart({ className = "w-6 h-6" }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 24 24" className={`${className} sp-heart-glyph`} aria-hidden data-testid="sp-heart-glyph">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f9a8c9" /><stop offset=".45" stopColor="#ec4899" /><stop offset=".8" stopColor="#e6b85c" /><stop offset="1" stopColor="#fde68a" /></linearGradient>
      </defs>
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill={`url(#g${id})`} stroke="#fff" strokeWidth=".8" />
      <path d="M7.6 6.2c-1.3.2-2.3 1.2-2.5 2.6" fill="none" stroke="#fff" strokeOpacity=".85" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M19.2 2.2l.45 1.15 1.15.45-1.15.45-.45 1.15-.45-1.15-1.15-.45 1.15-.45z" fill="#fde68a" />
    </svg>
  );
}

export const ReactionGlyph = ({ e, className }) => (e === SP_HEART ? <SpHeart className={className} /> : <>{e}</>);
